import DialogButtonModel from "./dialog-button.model";
import DialogType from "./dialog-type.enum";

export default class DialogModel {
  Title: string;
  Text: string;
  TitleBtnYes: string = "Ок";
  TitleBtnNo: string = "Отменить";
  Type: DialogType = DialogType.Info;
  Buttons: Array<DialogButtonModel>;
  constructor(object?: Partial<DialogModel>) {
    if (object) {
      this.Title = object.Title;
      this.Text = object.Text;
      this.TitleBtnYes = object.TitleBtnYes;
      this.TitleBtnNo = object.TitleBtnNo;
      this.Type = object.Type;
      this.Buttons = object.Buttons;
    }
  }
}
